import { createElement, Component, Fragment } from 'react';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

var CALENDLY_SCRIPT_SOURCE = "https://assets.calendly.com/assets/external/widget.js";
var CALENDLY_STYLESHEET_SOURCE = "https://assets.calendly.com/assets/external/widget.css";

var loadScript = function loadScript(onLoad) {
  var script = document.createElement("script");
  script.src = CALENDLY_SCRIPT_SOURCE;

  script.onload = onLoad || function () {
    return null;
  };

  document.body.appendChild(script);
};

var loadStyleSheet = function loadStyleSheet() {
  var link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = CALENDLY_STYLESHEET_SOURCE;
  document.body.appendChild(link);
};

var defaultStyles = {
  minWidth: "320px",
  height: "630px"
};

var InlineWidget =
/** @class */
function (_super) {
  __extends(InlineWidget, _super);

  function InlineWidget() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  InlineWidget.prototype.componentDidMount = function () {
    loadScript();
  };

  InlineWidget.prototype.render = function () {
    return createElement("div", {
      className: "calendly-inline-widget",
      style: this.props.styles || defaultStyles,
      "data-url": this.props.url
    });
  };

  return InlineWidget;
}(Component);

var createClickHandler = function createClickHandler(url) {
  return function (e) {
    e.preventDefault();
    return window.Calendly.initPopupWidget({
      url: url
    });
  };
};

var PopupText =
/** @class */
function (_super) {
  __extends(PopupText, _super);

  function PopupText() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  PopupText.prototype.componentDidMount = function () {
    if (!document.querySelector("script[src=\"" + CALENDLY_SCRIPT_SOURCE + "\"]")) {
      loadScript();
    }

    if (!document.querySelector("link[href=\"" + CALENDLY_STYLESHEET_SOURCE + "\"]")) {
      loadStyleSheet();
    }
  };

  PopupText.prototype.componentWillUnmount = function () {
    window.Calendly.closePopupWidget();
  };

  PopupText.prototype.render = function () {
    return createElement("a", {
      href: "",
      onClick: createClickHandler(this.props.url)
    }, this.props.text);
  };

  return PopupText;
}(Component);

var defaultProps = {
  branding: false,
  color: "#00a2ff",
  textColor: "#ffffff"
};

var PopupWidget =
/** @class */
function (_super) {
  __extends(PopupWidget, _super);

  function PopupWidget() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  PopupWidget.prototype.componentWillReceiveProps = function (nextProps) {
    window.Calendly.initBadgeWidget(_assign(_assign({}, defaultProps), nextProps));
  };

  PopupWidget.prototype.componentDidMount = function () {
    var options = _assign(_assign({}, defaultProps), this.props);

    var onLoad = function onLoad() {
      window.Calendly.initBadgeWidget(options);
    };

    if (!document.querySelector("script[src=\"" + CALENDLY_SCRIPT_SOURCE + "\"]")) {
      loadScript(onLoad);
    } else {
      window.Calendly.initBadgeWidget(options);
    }

    if (!document.querySelector("link[href=\"" + CALENDLY_STYLESHEET_SOURCE + "\"]")) {
      loadStyleSheet();
    }
  };

  PopupWidget.prototype.componentWillUnmount = function () {
    window.Calendly.destroyBadgeWidget();
    window.Calendly.closePopupWidget();
  };

  PopupWidget.prototype.render = function () {
    return createElement(Fragment, null);
  };

  return PopupWidget;
}(Component);

export { InlineWidget, PopupText, PopupWidget };